import { useState, type FC } from "react";
import BrandLogo from "../../components/BrandLogo";
import { Button } from "../../components/ui/button";
import { gluceraAssessmentCta } from "../../utils/gluceraTypography";
import { Card } from "../../components/ui/card";
import RadioDot from "../../components/common/RadioDot";
import { useNavigate } from "react-router-dom";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import SessionStorageHelper from "../../utils/sessionStorageHelper";

const Workoutpage: FC = () => {
  const navigate = useNavigate();
  const [selectedActivity, setSelectedActivity] = useState<string>("");

  const handleNext = () => {
    // Convert to Django choice keys
    let backendValue;
    if (selectedActivity === "Sedentary") {
      backendValue = "sedentary";
    } else if (selectedActivity === "Lightly active") {
      backendValue = "lightly_active";
    } else if (selectedActivity === "Moderately active") {
      backendValue = "moderately_active";
    } else if (selectedActivity === "Very active") {
      backendValue = "very_active";
    }

    // Save physical activity level to session storage
    SessionStorageHelper.saveField("activity_level", backendValue);

    // Navigate to the next assessment page (Diet page)
    navigate("/glucera" + GluceraNavigationRoutes.DIETPAGE);
  };

  const activities = [
    {
      value: "Sedentary",
      desc: "Mostly sitting",
    },
    {
      value: "Lightly active",
      desc: "3-5 walks or light workouts/week",
    },
    {
      value: "Moderately active",
      desc: "Exercise 3-5x/week, mix of cardio & strength",
    },
    {
      value: "Very active",
      desc: "6+ high-intensity sessions/week",
    },
  ];

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header */}
        <div className="space-y-4 px-4 pb-4 pt-safe">
          <BrandLogo />

          {/* Assessment Progress */}
          <p className="text-center text-subhead text-muted-foreground">
            Assessment 8 of 11
          </p>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto px-6 py-2">
          <div className="mb-6 space-y-2">
            <h1 className="text-title1 font-bold text-foreground sm:text-large-title">
              How Physically Active Are You?
            </h1>
            <p className="text-subhead text-muted-foreground">
              This helps us understand how your activity impacts blood sugar
            </p>
          </div>

          <div className="space-y-3">
            {activities.map(option => (
              <Card
                key={option.value}
                className={`cursor-pointer transition-all ${
                  selectedActivity === option.value
                    ? "border border-primary bg-primary/5"
                    : "border border-border hover:border-primary/50"
                }`}
                onClick={() => setSelectedActivity(option.value)}
              >
                <div className="flex items-start gap-3 p-4">
                  <RadioDot selected={selectedActivity === option.value} className="mt-0.5" />
                  <div className="flex-1">
                    <div className="cursor-pointer text-callout font-semibold text-foreground">
                      {option.value}
                    </div>
                    <p className="mt-1 text-caption1 text-muted-foreground">
                      {option.desc}
                    </p>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Footer Button */}
        <div className="pb-safe border-t p-4">
          <Button
            onClick={handleNext}
            disabled={!selectedActivity}
            className={gluceraAssessmentCta}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Workoutpage;
